import React, { InputHTMLAttributes } from 'react';
// @ts-expect-error unmaintained
import ReactToggle from 'react-toggle';

// A simple pass through component to the react-toggle vendor package. We can customize here later as needed.

export type ToggleProps = InputHTMLAttributes<HTMLInputElement> & {
  icons?: {
    checked?: JSX.Element;
    unchecked?: JSX.Element;
  };
};

export default function Toggle(props: ToggleProps): JSX.Element {
  return <ReactToggle {...props} />;
}
